import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Identifica',
    desc: "Eliges los 3 platos 'pilares' que definen tu identidad familiar."
  }, {
    num: '02',
    title: 'Documenta',
    desc: 'Aplicas el Método de la Entrevista para extraer los secretos invisibles.'
  }, {
    num: '03',
    title: 'Preserva',
    desc: 'Usas nuestras plantillas para crear un libro digital que nunca se borrará.'
  }];
  return <section className="py-24 bg-heritage-cream bg-paper-texture" data-id="element-76">
      <div className="max-w-5xl mx-auto px-6 content-relative" data-id="element-77">
        <FadeIn data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-79">
            ¿Cómo funciona?
          </h2>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-3 gap-8 relative" data-id="element-80">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-heritage-gold/20 z-0" data-id="element-81"></div>

          {steps.map((step, idx) => <StaggerItem key={idx} className="relative z-10 text-center" data-id="element-82">
              <div className="w-24 h-24 mx-auto bg-heritage-beige rounded-full border-4 border-white shadow-sm flex items-center justify-center mb-6" data-id="element-83">
                <span className="font-serif text-3xl font-bold text-heritage-terracotta" data-id="element-84">
                  {step.num}
                </span>
              </div>
              <h3 className="font-serif text-2xl font-semibold mb-4 text-heritage-coffee" data-id="element-85">
                {step.title}
              </h3>
              <p className="text-heritage-coffee/80 text-lg" data-id="element-86">{step.desc}</p>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}